import { useMemo, useState } from 'react'

import { IntervalVariants } from '../types'

type useDatePickerIntervalProps = {
  intervals?: IntervalVariants[]
  interval?: IntervalVariants
  onChangeInterval?: (interval: IntervalVariants) => void
}

const useDatePickerInterval = ({ intervals, interval, onChangeInterval }: useDatePickerIntervalProps) => {
  const [innerInterval, setInnerInterval] = useState<IntervalVariants>(
    interval || intervals?.[0] || IntervalVariants.DAY,
  )

  const currentInterval: IntervalVariants = useMemo(
    () => (onChangeInterval ? (interval as IntervalVariants) : innerInterval),
    [innerInterval, interval, onChangeInterval],
  )

  const handleChangeInterval = (newInterval: IntervalVariants) => {
    if (onChangeInterval) {
      onChangeInterval(newInterval)
    } else {
      setInnerInterval(newInterval)
    }
  }

  return {
    currentInterval,
    handleChangeInterval,
  }
}

export { useDatePickerInterval }
